module.exports = __webpack_public_path__ + "img/eeg_thumb.68114b88.png";